export const getDocsMetaData = async ({ selectedProjectId, itemUrn, accessToken  }) => {
    if (!accessToken || !selectedProjectId || !itemUrn) {
        throw new Error('Missing required parameters for fetching items meta data');
    }

    // Prepare the request headers
    const requestHeaders = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    });

    // Prepare the request object
    const request = new Request(`https://developer.api.autodesk.com/data/v1/projects/${selectedProjectId}/items/${itemUrn}`, {
        method: 'GET',
        headers: requestHeaders
    });
    try {
        // Make the fetch request
        const response = await fetch(request);

        // Check if the response is okay
        if (!response.ok) {
            throw new Error(`HTTP error from relationships! Status: ${response.status} ${response.statusText}`);
        }
        const itemData = await response.json();
        console.log('Fetched item data:', itemData);
        // TODO could the be more items in the included array?
        console.log('Fetched derivative urn:', itemData.included[0].relationships.derivatives.data.id);
        return itemData;


    } catch (error) {
        // Log and rethrow any errors encountered
        console.error('Error fetching relationships meta data:', error);
        throw error;
    }
};
